import React from 'react';

const Navbar = () => {
    return (
        <div>
            <nav className="navbar navbar-dark bg-dark mb-5">
                <span className="navbar-brand mb-0 h1 mx-auto title">Lyrix</span>
            </nav>
        </div>
    )
}

export default Navbar;
